import React from "react";
import {
  Person,
  People,
  HeartPulse,
  FileEarmarkMedical,
  ListCheck,
  Clipboard2Pulse,
  Hospital,
  FileEarmarkText,
  Eye, // Changed from Tooth to Eye for Optical
} from "react-bootstrap-icons";

const baseIcons = [
  Person,
  People,
  HeartPulse,
  FileEarmarkMedical,
  ListCheck,
  Clipboard2Pulse,
  Hospital,
  FileEarmarkText,
];

const VerticalStepper = ({ steps, activeStep, isHorizontal }) => {
  return (
    <div
      className={`${
        isHorizontal ? "vertical-stepper-flex" : "vertical-stepper"
      } shadow-md`}
      role="list"
    >
      {steps.map((step, index) => {
        const isOpticalStep = step.label === "Optical Details"; // Changed from Dental
        const Icon = isOpticalStep ? Eye : baseIcons[index] || Person;
        const isActive = index === activeStep;
        const isCompleted = index < activeStep;
        const isLastStep = index === steps.length - 1;

        return (
          <div
            key={index}
            className="stepper-step"
            role="listitem"
            aria-current={isActive ? "step" : undefined}
          >
            <div className="step-icon-wrapper">
              <div
                className={`step-icon ${
                  isCompleted ? "completed" : isActive ? "active" : ""
                }`}
                aria-label={`Step ${index + 1}: ${step.label}${
                  isCompleted ? " - Completed" : isActive ? " - Current" : ""
                }`}
              >
                {isOpticalStep ? ( // Changed condition
                  <Eye size={18} aria-hidden="true" />
                ) : (
                  <Icon size={18} aria-hidden="true" />
                )}
              </div>

              {!isLastStep && (
                <div
                  className={`connector-line ${isCompleted ? "filled" : ""}`}
                  aria-hidden="true"
                />
              )}
            </div>

            <div
              className={`step-label fs-10 ${
                isActive || isCompleted ? "active" : ""
              }`}
              id={`step-label-${index}`}
            >
              {step.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default VerticalStepper;
